import styled from "styled-components";

const StyledContainer = styled.div`
  header {
    border-bottom: 1px solid #c9c8c8;
    color: #1e1919;
    font-weight: 700;
    padding: 16px 32px;
  }
`;

export default StyledContainer;
